<app-page-container id="register-container">
    <app-narrow-wrap>
        @if(showHIDError) {
            <uimc-alert title="" indicator="error" submit-button-label="" cancel-button-label="" class="col-12 margin-bottom-1">
                {{ 'HID_MAINTENANCE_ERROR' | translate }}
            </uimc-alert>
        }
        @else {
            <app-block-centered>
                <app-headline headline="REGISTER_TITLE"></app-headline>
            </app-block-centered>
            <app-register-form (registered)="postRegister($event)"></app-register-form>
        }
    </app-narrow-wrap>
</app-page-container>
